import { render, staticRenderFns } from "./GlyphTooltip.vue?vue&type=template&id=3afb89c8&scoped=true"
import script from "./GlyphTooltip.vue?vue&type=script&lang=js"
export * from "./GlyphTooltip.vue?vue&type=script&lang=js"
import style0 from "./GlyphTooltip.vue?vue&type=style&index=0&id=3afb89c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afb89c8",
  null
  
)

export default component.exports